import { fetchWithCache, getCachedData } from "../services/apiService";

export const propertiesSoldRecent = async ({ setPropertiesSoldRecentt }) => {
  // Show cached data immediately if available (for fast initial load)
  const cached = getCachedData("/api/property/soldRecent", {});
  if (cached) {
    setPropertiesSoldRecentt(cached);
  }

  try {
    // Fetch fresh data; cache is used as fallback if API is sleeping
    const data = await fetchWithCache(
      "/api/property/soldRecent",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    const result = Array.isArray(data) ? data : [];
    setPropertiesSoldRecentt(result);
  } catch (error) {
    if (!cached) {
      setPropertiesSoldRecentt([]);
    }
  }
};
